import { useCRMStore } from '../../store/crmStore';

/**
 * A CRM store « create » judged on its own result (relecture du 13/10/2026): it gives the row it
 * made, or null on a failure whose message the slice has just kept in `error`. The writes that
 * change a row return their failure themselves (`writeResult`).
 */
export async function createdOrFailure(created: Promise<unknown>, refused: string): Promise<string | null> {
  const row = await created;
  return row ? null : (useCRMStore.getState().error ?? refused);
}
